import { Container, NotesIndex, Section, Stack } from "@humaniti/ui";
import { NOTES } from "../content/notes";
import { SEO } from "../lib/seo";

export const FieldNotesIndexPage = () => (
  <>
    <SEO
      title="Field notes — Editorial"
      description="Long-form essays from inside the Network. Methodology posts, Human spotlights, dataset releases. Published when something is worth publishing, not on a schedule."
      path="/notes"
    />
    <Section>
      <Container size="default">
        <Stack gap="2xl">
          <header>
            <span
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: "var(--fs-label)",
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                color: "var(--fg-secondary)",
              }}
            >
              § Field notes
            </span>
            <h1
              style={{
                margin: "var(--space-3) 0 0",
                fontFamily: "var(--font-sans)",
                fontWeight: 500,
                fontSize: "var(--fs-display)",
                lineHeight: "var(--lh-display)",
                letterSpacing: "-0.02em",
              }}
            >
              Editorial<span style={{ color: "var(--teal)" }}>.</span>
            </h1>
            <p
              style={{
                margin: "var(--space-4) 0 0",
                maxWidth: 720,
                fontSize: "var(--fs-body-lg)",
                lineHeight: "var(--lh-body-lg)",
                color: "var(--fg-secondary)",
              }}
            >
              Long-form notes from inside the Network — methodology, the public roadmap arc, the
              people who do the work. Published when something is worth publishing, not on a
              schedule.
            </p>
          </header>
          <NotesIndex posts={NOTES.map((n) => n.frontmatter)} />
        </Stack>
      </Container>
    </Section>
  </>
);
